import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const SimpleGrid = ({ children, align, direction, theme }) => {
	const simpleGridCx = cx(
		styles.grid,
		styles[`align_${align}`],
		styles[`theme_${theme}`],
		styles[`direction_${direction}`]
	);

	return (
		<div className={simpleGridCx}>
			{React.Children.map(children, (block) => (
				<div className={styles.col} key={block.key}>
					{block}
				</div>
			))}
		</div>
	);
};

SimpleGrid.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	align: PropTypes.oneOf(['centerHorizontal']),
	theme: PropTypes.oneOf(['verticalCards', 'horizontalCards']),
	direction: PropTypes.oneOf(['columns'])
};

export default SimpleGrid;
